import React from "react";

const Minimize = () => {
  return (
    <img
      className="imgChangePopupSize"
      alt="minimize"
      width="20px"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAz0lEQVR4nO2VMQrCQBBFn2ewTmVhJRaChWClV/AGMXoLPYYeQywlITapvIq5grIwRZCdkY1rYfDDbzbDf8xOdhe6pAy4RPLaByiBOkJ4DRQawPshUOXPAzIg/SZAlQUYAJMXu7UogAR4KB556t32bEI7WAArcdUAzDy1OXD1hZyBk9kj7CT41gbQF2vaS+gBWLYBWBpL4BHoyZYFA6y7aAvMJdxpagxZBWh3Ue0ZvgMNlW5NQBHhAOZ/wDt9NOREDqT14Nzb/KZpAKBZ3wE9AW9BhViWm4kzAAAAAElFTkSuQmCC"
    />
  );
};

export default Minimize;
